import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.lucky_wheel.wheel,
    props.lucky_wheel.timeout,
    (wheel, timeout) => {
        return {
            wheel,
            timeout
        }
    }
)